import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserGroupFilterQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters?: Types.InputMaybe<Types.GroupsFilters>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type UserGroupFilterQuery = { groups: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, type: Types.GroupTypeEnum } | { id: string, name: string, type: Types.GroupTypeEnum } }> | null } };


export const UserGroupFilterDocument = /*#__PURE__*/ gql`
    query userGroupFilter($sort: [SortType!], $filters: GroupsFilters, $after: String, $first: Float) {
  groups(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ... on UserCollectionGroupType {
          id
          name
          type
        }
        ... on ContentCollectionGroupType {
          id
          name
          type
        }
      }
    }
  }
}
    `;

export function useUserGroupFilterQuery(options?: Omit<Urql.UseQueryArgs<UserGroupFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<UserGroupFilterQuery, UserGroupFilterQueryVariables>({ query: UserGroupFilterDocument, ...options });
};